import React from 'react';

const UserAgreement: React.FC = () => (
  <div style={{ padding: 24, maxWidth: 800, margin: '0 auto', background: '#fff', borderRadius: 8 }}>
    <h1>用户使用协议</h1>
    <p>欢迎您使用达康AI医生平台。在使用本平台前，请您仔细阅读本协议的所有内容。若您不同意本协议的任意内容，请勿注册或使用本平台服务。</p>
    <h2>1. 服务内容</h2>
    <p>本平台为用户提供健康咨询、问答等相关服务。</p>
    <h2>2. 用户义务</h2>
    <p>用户应保证所填写信息真实有效，不得冒用他人身份。</p>
    <h2>3. 隐私保护</h2>
    <p>平台将严格保护用户的个人信息安全，详见《平台隐私政策》。</p>
    <h2>4. 免责声明</h2>
    <p>平台提供的信息仅供参考，不能替代专业医疗建议。</p>
    <h2>5. 其他</h2>
    <p>本协议最终解释权归达康AI医生平台所有。</p>
  </div>
);

export default UserAgreement; 